@if (hold(); as h) {
  @if (isHeld()) {
    <!-- PRE-SIZING (`DOC-58` UI-DA-58-02). 🚨 Nothing in this section is, or
         reserves room for, a facility size (UI-DA-58-01): sizing is blocked, so
         no figure exists to show, place or imply. -->
    <section class="sizing-hold" role="status" aria-labelledby="sizing-hold-title">
      <p class="sizing-hold__headline" id="sizing-hold-title">
        <app-icon name="clock" [size]="18" aria-hidden="true" />
        <span><strong>Held</strong> — {{ h.reason_label }}</span>
      </p>

      <!-- UI-DA-58-04: recorded by a named actor as at a recorded moment.
           Never "now" — this is an Ops record, not a live system state. -->
      <p class="sizing-hold__record">
        Recorded by {{ actor() }} as at {{ h.raised_at | date: 'medium' }}
      </p>

      <p class="sizing-hold__consequence">{{ consequence() }}</p>

      <!-- FLOW-343 / DOC-77 §3: which source, which way, and its share — every
           figure as the record holds it. §4: nothing here is computed. -->
      @if (movements().length) {
        <ul class="sizing-hold__movements">
          @for (m of movements(); track $index) {
            <li class="sizing-hold__movement">
              <span>
                {{ directionLabel(m.direction) }} what may be another account of the client's:
                <strong>{{ m.source }}</strong>
              </span>
              <span class="sizing-hold__share">
                {{ m.total | zar }} over the assessment period —
                @if (m.share_percent !== null) {
                  {{ m.share_percent }}% of the period's gross credits ({{ grossCredits() | zar }}).
                } @else {
                  its share of the period's gross credits could not be measured.
                }
              </span>
            </li>
          }
        </ul>
      }

      <!-- FLOW-284: the hold came straight back after a release. Shown before
           the ask, because it is the reason the ask is still standing.
           FLOW-287: the trailing clause is per-limb — what brought the hold
           back differs, and one sentence for both would misreport one of them. -->
      @if (reHeld(); as again) {
        <p class="sizing-hold__re-held">
          <app-icon name="refresh" [size]="16" aria-hidden="true" />
          <span>
            Re-held at {{ again.at | date: 'shortTime' }} straight after a release —
            {{ again.detail }}
          </span>
        </p>
      }

      @if (ask(); as nextStep) {
        <p class="sizing-hold__ask">
          <span class="sizing-hold__ask-label">Next step</span>
          <span>{{ nextStep }}</span>
        </p>
      }

      <!-- 🚨 FLOW-284: the release action is WITHHELD, not disabled, while the
           client has not affirmed its list. A disabled button says "not you,
           not now"; there is no tier that unlocks this and no waiting that
           does — the client has to act first, and the ask above says so. The
           server refuses it too (409 AFFIRMATION_REQUIRED), so a button here
           would be an invitation to an error. -->
      @if (canRelease()) {
        <button
          mat-stroked-button
          type="button"
          class="sizing-hold__release"
          (click)="openRelease()"
          data-testid="sizing-hold-release"
        >
          <app-icon name="check" [size]="18" />
          Release hold
        </button>
      } @else {
        <p class="sizing-hold__withheld">
          Release becomes available once the client confirms its list on the bank step.
        </p>
      }
    </section>
  }
}
